import React, {
  useMemo,
  useCallback,
  FC,
}                        from 'react';
import {
  ITax,
  ITaxesValues,
}                        from '@typings/invoiceManagement';
import { TDataTableRow } from '@typings/components';
import { Field }         from 'formik';
import { CurrencyInput } from '@components/index';
import {
  useFetchTaxes,
  useUpdateTaxes,
}                        from '@modules/invoiceManagement/queries/invoiceManagementQueries';
import { UseTaxPage }    from '../pages/UseTaxPage';

const getTaxes = (taxes: ITax[]): TDataTableRow[] => taxes.map((
  tax   : ITax,
  index : number,
): TDataTableRow => [
  { value: tax.stateName },
  {
    align : 'right',
    value : (
      <Field
        id        = {`taxes[${index}].taxValue`}
        name      = {`taxes[${index}].taxValue`}
        component = {CurrencyInput}
        prefix    = ""
        suffix    = "%"
        maxLength = {8}
      />
    ),
  },
]);

export const UseTaxContainer: FC = () => {
  // #region API INTEGRATION
  const {
    data: taxesData = [],
    isFetching,
  } = useFetchTaxes();

  const { mutateAsync: saveTaxes, isLoading } = useUpdateTaxes();
  // #endregion

  const formattedTaxes = useMemo(
    () => (!taxesData.length ? [] : taxesData.map((tax) => ({
      ...tax,
      taxValue: tax.taxValue * 100,
    }))),
    [taxesData],
  );

  const tableRows = useMemo<TDataTableRow[]>(
    () => getTaxes(formattedTaxes),
    [formattedTaxes],
  );

  const handleSubmit = useCallback(
    async ({ taxes }: ITaxesValues): Promise<void> => {
      await saveTaxes({ taxes: taxes.map((tax) => ({
        ...tax,
        taxValue: tax.taxValue / 100,
      })) });
    },
    [saveTaxes],
  );

  return (
    <UseTaxPage
      rows          = {tableRows}
      isLoading     = {isLoading || isFetching}
      initialValues = {{ taxes: formattedTaxes }}
      handleSubmit  = {handleSubmit}
    />
  );
};
